// Все тексты лендинга в одном месте — меняйте здесь.
//
// `icon` в блоках ссылается на ключ из набора иконок в Landing.jsx
// (moon | heart | star | headphones | smile | wand | shield | lock).

export const LANDING = {
    hero: {
        badge: 'Сказки на ночь для детей 4–8 лет',
        // Заголовок героя берётся из HERO_VARIANTS (A/B-тест) — см. heroConfigs.js.
        subtitle: 'Добрые истории с любимыми героями помогают ребёнку понимать важные вещи, развивать характер и расти добрым, смелым и уверенным в себе.',
        cta: 'Создать сказку',
        socialProof: 'Более 2 500 семей уже с нами',
    },

    // Полоса преимуществ под героем.
    features: [
        {icon: 'moon', title: 'Легче засыпать', text: 'Добрые истории помогают спокойно переключиться ко сну.'},
        {icon: 'heart', title: 'Тёплые моменты вместе', text: 'Время, которое ребёнок запомнит надолго.'},
        {
            icon: 'star',
            title: 'Развивает и вдохновляет',
            text: 'Сказки учат добру, смелости и дружбе в увлекательной форме.'
        },
        {
            icon: 'headphones',
            title: 'Профессиональная озвучка',
            text: 'Приятные голоса и музыка погружают в атмосферу волшебства.'
        },
    ],

    // Встроенное приложение — второй экран лендинга, перед отзывами.
    appSection: {
        title: 'Создайте сказку прямо сейчас',
    },

    // Отзывы родителей.
    testimonials: {
        title: 'Почему родители выбирают нас',
        items: [
            {
                quote: 'Сын стал внимательнее и добрее. Обсуждаем истории каждый вечер.',
                name: 'Мария',
                sub: 'мама Егора, 6 лет',
                avatar: '/reviews/avatar-1.jpg'
            },
            {
                quote: 'Дочка полюбила читать и сама рассказывает придуманные сказки.',
                name: 'Анна',
                sub: 'мама Алисы, 5 лет',
                avatar: '/reviews/avatar-2.jpg'
            },
            {
                quote: 'Сказки помогают говорить о важных вещах без нотаций и споров.',
                name: 'Людмила',
                sub: 'мама Максима, 7 лет',
                avatar: '/reviews/avatar-3.jpg'
            },
            {
                quote: 'Каждый вечер ждём новое приключение. Это наш семейный ритуал.',
                name: 'Ольга',
                sub: 'мама Софии, 4 года',
                avatar: '/reviews/avatar-4.jpg'
            },
        ],
    },

    // Как это работает.
    howItWorks: {
        title: 'Всего 3 шага до волшебной сказки',
        steps: [
            {icon: 'smile', title: 'Укажите имя и возраст ребёнка', text: 'Мы создадим героя, похожего на него.'},
            {icon: 'wand', title: 'Выберите тему', text: 'Приключения, дружба, добро, смелость и многое другое.'},
            {
                icon: 'headphones',
                title: 'Слушайте вместе',
                text: 'Сказка готова за минуту. Слушайте, обсуждайте и наслаждайтесь.'
            },
        ],
        cta: 'Создать сказку',
    },

    // Доверие — нижняя полоса.
    trust: [
        {
            icon: 'shield',
            title: 'Безопасно для детей',
            text: 'Без рекламы и подписок внутри. Контент одобрен родителями.'
        },
        {icon: 'lock', title: 'Конфиденциально', text: 'Мы не передаём данные третьим лицам.'},
        {icon: 'heart', title: 'Сделано с любовью', text: 'Каждая история создаётся с заботой о вашем ребёнке.'},
    ],

    // Бренд — логотип и подпись в шапке и подвале.
    // Имя разбито на части, чтобы выделить одну букву цветом (titleAccent).
    brand: {
        titleBefore: 'Магазин чудec',
        tagline: 'персональные сказки для детей',
    },

    // Текст CTA-кнопки в шапке.
    headerCta: 'Создать сказку',
};
